import { Controller } from "@hotwired/stimulus"

// Client-side-only sub-nav for the mission show page's Tracking tab (card
// #3613, round 16) -- All / Tracked / Objectives / Insights / Reportable.
// Deliberately NOT an extension of response_status_filter_controller.js: that
// controller paginates via a server round trip (a fresh turbo-frame fetch per
// tab), while every card here is already rendered on the page, so this only
// ever toggles `hidden` on the group wrappers and moves the active-pill
// classes -- the same mechanism response_status_filter_controller.js#setActiveTab
// uses, minus the fetch.
//
// Insights and Reportable are filtered views of the Tracked group, so All
// shows Tracked + Objectives only -- no card appears twice on the default view.
export default class extends Controller {
  static targets = [
    "allPill", "trackedPill", "objectivesPill", "insightsPill", "reportablePill",
    "trackedGroup", "objectivesGroup", "insightsGroup", "reportableGroup"
  ]

  connect() {
    this.showAll()
  }

  showAll(event) {
    event?.preventDefault()
    this._show(["trackedGroup", "objectivesGroup"], "allPill")
  }

  showTracked(event) {
    event?.preventDefault()
    this._show(["trackedGroup"], "trackedPill")
  }

  showObjectives(event) {
    event?.preventDefault()
    this._show(["objectivesGroup"], "objectivesPill")
  }

  showInsights(event) {
    event?.preventDefault()
    this._show(["insightsGroup"], "insightsPill")
  }

  showReportable(event) {
    event?.preventDefault()
    this._show(["reportableGroup"], "reportablePill")
  }

  _show(visibleGroups, activePill) {
    this._groupNames.forEach(name => {
      const group = this._target(name)
      if (group) group.classList.toggle("hidden", !visibleGroups.includes(name))
    })
    this._setActivePill(this._target(activePill))
  }

  _setActivePill(activePill) {
    this._pillNames.map(name => this._target(name)).filter(Boolean).forEach(pill => {
      pill.classList.remove("border-blue-500", "text-blue-600")
      pill.classList.add("border-transparent", "text-gray-500")
    })
    if (!activePill) return

    activePill.classList.remove("border-transparent", "text-gray-500")
    activePill.classList.add("border-blue-500", "text-blue-600")
  }

  // Safe target lookup -- returns null rather than throwing when a target is
  // missing (stimulus.md "Target Safety").
  _target(name) {
    const hasKey = `has${name.charAt(0).toUpperCase()}${name.slice(1)}Target`
    return this[hasKey] ? this[`${name}Target`] : null
  }

  get _groupNames() {
    return ["trackedGroup", "objectivesGroup", "insightsGroup", "reportableGroup"]
  }

  get _pillNames() {
    return ["allPill", "trackedPill", "objectivesPill", "insightsPill", "reportablePill"]
  }
}
